export default {"src":"/_next/static/media/logo.58432bc5.svg","height":366,"width":1363,"blurWidth":0,"blurHeight":0};